module.exports = __webpack_public_path__ + "img/21.92e7de6d.svg";